import React from 'react';
import { FileEdit, Phone, MessageCircle, GraduationCap, Plane, Building2 } from 'lucide-react';
import { marqueeItems } from '../data/mock';

const iconMap = { FileEdit, Phone, MessageCircle, GraduationCap, Plane, Building2 };

export default function Marquee() {
  const items = [...marqueeItems, ...marqueeItems, ...marqueeItems];
  return (
    <div className="bg-primary text-white overflow-hidden relative">
      <div className="flex animate-marquee whitespace-nowrap py-2.5">
        {items.map((it, i) => {
          const Icon = iconMap[it.icon];
          return (
            <div key={i} className="flex items-center gap-2 px-6 shrink-0 text-xs md:text-sm font-medium tracking-wide">
              <Icon className="w-4 h-4 text-brand" strokeWidth={2} />
              <span>{it.text}</span>
              <span className="text-brand ml-4">✦</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
